import React from 'react';
import PropTypes from 'prop-types';
import { globalTheme as GlobalColors } from '@playbookux/playbook-web-core';
import Barchart from '../../../../../../../../core/components/charts/bar-chart';

import {
  Container,
} from './styles';

const SuccessFailureStats = (props) => {
  const { statistics } = props;

  const percentageValues = () => {
    if (statistics) {
      const {
        directSuccess,
        indirectSuccess,
        directFailure,
        indirectFailure,
      } = statistics;

      const dataset = [directSuccess.percentage, indirectSuccess.percentage, directFailure.percentage, indirectFailure.percentage];
      return dataset;
    }
    return [0, 0, 0, 0];
  };

  const data = {
    labels: ['Direct Success', ['Indirect', 'Success'], 'Direct failure', ['Indirect', 'Failure']],
    datasets: [
      {
        label: '# of Votes',
        data: percentageValues(),
        datalabels: {
          display: true,
          anchor: 'end',
          align: 'top',
        },
        backgroundColor: [
          GlobalColors.color.directSuccess,
          GlobalColors.color.indirectSuccess,
          GlobalColors.color.directFailure,
          GlobalColors.color.indirectFailure,
        ],
      },
    ],
  };

  return (
    <Container>
      <Barchart
        data={data}
        type="bar"
        stepSize={25}
        maxHeightValue={100}
        height={300}
        width={1000}
        paddingTop={30}
      />
    </Container>
  );
};

SuccessFailureStats.propTypes = {
  statistics: PropTypes.shape({
    directSuccess: PropTypes.shape({
      total: PropTypes.number,
      percentage: PropTypes.number,
    }),
    indirectSuccess: PropTypes.shape({
      total: PropTypes.number,
      percentage: PropTypes.number,
    }),
    directFailure: PropTypes.shape({
      total: PropTypes.number,
      percentage: PropTypes.number,
    }),
    indirectFailure: PropTypes.shape({
      total: PropTypes.number,
      percentage: PropTypes.number,
    }),
  }).isRequired,
};

export default SuccessFailureStats;
